export const endpoints = {
  sendGiftCardEmail: code => `/dashboard/orders/${code}/send-gift-card-email`,
  getPopularGifts: '/dashboard/orders/popular-gifts',
  getAcceptanceRate: code => `/dashboard/orders/${code}/acceptance-rate`,
  orders: () => `/dashboard/orders`,
  thankYouNotes: () => `/dashboard/orders/thank-you-notes`,
  dashboardSummary: () => `/dashboard/analytics/dashboard-summary`,
  getGraphData: () => `/dashboard/analytics/redemption-graph`
};
